import { render, staticRenderFns } from "./pg-xptx.vue?vue&type=template&id=c7eac9b2&scoped=true&"
import script from "./pg-xptx.vue?vue&type=script&lang=js&"
export * from "./pg-xptx.vue?vue&type=script&lang=js&"
import style0 from "./pg-xptx.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./pg-xptx.vue?vue&type=style&index=1&id=c7eac9b2&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c7eac9b2",
  null
  
)

export default component.exports